import actions from './actions';
import getters from './getters';
import mutations from './mutations';

const state = {
  menuOpen: false,
  notificationCenterOpen: false,
  notifications: {
    unreadMessages: 0,
    newSwaps: 0,
    onboarding: 0,
    pendingPayments: 0
  },
  // Superlike balance, kept outside `notifications` (which is replaced on
  // every refetch) so only a real change re-renders the cards that read it.
  // undefined = no balance (freemium/trial or not fetched yet), 0 = used up.
  superLikesRemaining: undefined,
  showAttentionDot: false,
  showMobileTabBar: true,
  stickyTabBar: true,
  chatOwnerId: undefined
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
};
